export default __webpack_public_path__ + "images/M7.52b0fb8.png";